module.exports = __webpack_public_path__ + "img/1.8de979b4.jpg";